module.exports = __webpack_public_path__ + "img/Accessories.a5110197.png";